import React from "react";

const FormSocials = (props) => {
  const {
    values,
    handleChange,
    handleBlur,
    errors, touched,
    setFieldValue
  } = props;
  return (
    <React.Fragment>
      <div className="add_utf_listing_section margin-top-45">
        <div className="utf_add_listing_part_headline_part">
          <h3>
            <i className="sl sl-icon-list"></i> Social Networks
          </h3>
        </div>
        <div className="row with-forms">
          <div className="col-md-6">
            <h5>Facebook URL</h5>
            <input
              type="url"
              name="fb"
              placeholder="https://www.facebook.com/your-fb"
              value={`${values.fb || ''}`}
              onChange={handleChange}
              onBlur={handleBlur}
              className={errors.fb && touched.fb ? " error" : ""}
            />
          </div>
          <div className="col-md-6">
            <h5>Twitter URL</h5>
            <input
              type="url"
              name="tw"
              placeholder="https://twitter.com/your-tw"
              value={`${values.tw || ''}`}
              onChange={handleChange}
              onBlur={handleBlur}
              className={errors.tw && touched.tw ? " error" : ""}
            />
          </div>
          <div className="col-md-6">
            <h5>Instagram URL</h5>
            <input
              type="url"
              name="ins"
              placeholder="https://www.instagram.com/your-ins"
              value={`${values.ins || ''}`}
              onChange={handleChange}
              onBlur={handleBlur}
              className={errors.ins && touched.ins ? " error" : ""}
            />
          </div>
          <div className="col-md-6">
            <h5>Youtube URL</h5>
            <input
              type="url"
              name="ytb"
              placeholder="https://www.youtube.com/your-channel"
              value={`${values.ytb || ''}`}
              onChange={handleChange}
              onBlur={handleBlur}
              className={errors.ytb && touched.ytb ? " error" : ""}
            />
          </div>
        </div>
      </div>
    </React.Fragment>
  );
};

export default FormSocials;
